import { isExtensionAddendumInGrace } from '@/utils/extensionAddendumGrace';

function normalizeStatus(status: string | null | undefined): string {
  if (!status) return '';
  return status.trim().toLowerCase().replace(/_/g, '-');
}

function getMissionEndDate(mission: Record<string, unknown>): string | null {
  const raw = mission.end_date ?? mission.endDate;
  if (raw == null || raw === '') return null;
  return String(raw);
}

function hasPendingFreelancerExtension(mission: Record<string, unknown>): boolean {
  return Number(mission.pending_addenda_count ?? mission.pendingAddendaCount ?? 0) > 0;
}

/**
 * Mission clôturée côté statut mais prolongation encore actionnable (grâce 30j).
 * Couvre l’écart où display_status reste "completed" alors que pending_addenda_count > 0.
 * Si display_status est déjà pending-freelancer-extension, le flux standard suffit.
 */
export function isFreelancerExtensionGraceNotificationMission(
  mission: Record<string, unknown>,
  displayStatus: string
): boolean {
  if (!hasPendingFreelancerExtension(mission)) return false;

  const endDate = getMissionEndDate(mission);
  if (!endDate || !isExtensionAddendumInGrace(endDate)) return false;

  const display = normalizeStatus(displayStatus);
  if (display === 'pending-freelancer-extension') return false;

  const dbStatus = normalizeStatus(mission.status as string | undefined);
  return (
    display === 'completed' ||
    display === 'terminated' ||
    display === 'early-terminated' ||
    dbStatus === 'completed' ||
    dbStatus === 'terminated'
  );
}
